<div style="width: 100%;text-align: center;margin-top: 10px;align-items: center;">
    <button class="btn btn-info" style="margin-left: 35px;" (click)="setReportType('SP500')">SP 500</button>
    <button class="btn btn-info" style="margin-left: 35px;" (click)="setReportType('DOW30')">DOW 30</button>
    <button class="btn btn-info" style="margin-left: 35px;" (click)="setReportType('NASDAQ100')">NASDAQ100</button>
</div>
<div style="height:25px"></div>
<div id="main" style="width:100%;height:1000px;align-items: center;"></div>
<div style="height:25px"></div>